import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { spacing, typography } = themeVariables;

export const heading = css`
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  margin: 0 0 var(${spacing.md});
`;

export const content = css`
  p {
    font-size: var(${typography.body.sizes.md.fontSize});
    line-height: var(${typography.body.sizes.md.lineHeight});
    margin: 0 0 var(${spacing.lg});
  }
`;
